module.exports = __webpack_public_path__ + "static/media/icon-rimula.d9987690.svg";